const templates = [
    {
        'id': 0,
        'template': '当{{subspace}}时， {{groupby}} 包含了 {{parameter}} 个类别: {{no.1}}、{{no.2}}、{{no.3}}',
    },
    {
        'id': 1,
        'template': '当{{subspace}}时，数据中的 {{groupby}}s 可以被归为 {{parameter}} 类，包括 {{no.1}}、{{no.2}}、{{no.3}}',
    },
    {
        'id': 2,
        'template': '当{{subspace}}时，数据中包含 {{parameter}} 种 {{groupby}}s，分别是 {{no.1}}、{{no.2}}、{{no.3}}.',
    }
]

export default templates;